export default __webpack_public_path__ + "static/media/f-bg.52d8fe89.jpg";